module.exports = __webpack_public_path__ + "static/media/GB.d072ff32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GB.svg
// module id = 256
// module chunks = 0